import React, {Component, Fragment} from 'react';
import { connect } from "react-redux";
import {IRootState} from "../../store";
import ApiService from "../ApiService";
import ISchoolUsageSummary, {IUsageArea} from "../../models/usage-analytics/ISchoolUsageSummary";
import {ISchoolUsageDetail} from "../../models/usage-analytics/ISchoolUsageDetail";
import LoadingPage from "../LoadingPage";
import {SchoolUsageFactsCard} from "./SchoolUsageFactsCard";
import moment from "moment";
import {FRIENDLY_DATE_FORMAT} from "../../utils/Utils";
import {Dropdown} from "office-ui-fabric-react";
import IUsageDatasetSummary from "../../models/usage-analytics/IUsageDatasetSummary";
import SchoolPageTitle from '../SchoolPageTitle';
import AdminSchoolMenu from '../AdminSchoolMenu';

interface UsageSchoolDetailPageProps {
    tenantId: string;
    schoolCode: string;
    datasetId: string;
    
    apiService: ApiService;
}

interface UsageSchoolDetailPageState {
    summary?: ISchoolUsageSummary;
    detail?: ISchoolUsageDetail;
    completedDatasets?: IUsageDatasetSummary[];
}


class UsageSchoolDetailPage extends Component<UsageSchoolDetailPageProps, UsageSchoolDetailPageState> {
    static displayName = UsageSchoolDetailPage.name;

    constructor(props: UsageSchoolDetailPageProps) {
        super(props);

        this.state = {
        };
    }

    async componentDidMount(): Promise<void> {
        
        const detailAndSummary = await this.props.apiService.getSchoolUsageSummaryAndDetail(this.props.tenantId,this.props.schoolCode,this.props.datasetId);
        const completedDatasets = await this.props.apiService.getCompletedUsageDatasetsForSchool(this.props.tenantId,this.props.schoolCode);
        
        this.setState({
            summary: detailAndSummary.summary,
            detail: detailAndSummary.detail,
            completedDatasets: completedDatasets
        });
    }

    componentDidUpdate(prevProps: Readonly<UsageSchoolDetailPageProps>, prevState: Readonly<UsageSchoolDetailPageState>, snapshot?: any): void {

    }

    render(): JSX.Element {
        
        if(this.state.summary === undefined || this.state.completedDatasets === undefined)
        {
            return <LoadingPage/>;
        }
        
        const datasetOptions = this.state.completedDatasets!.map(d => {
            return {
                text: moment(d.createdAt).format(FRIENDLY_DATE_FORMAT),
                key: d.id,
                data: d
            };
        })
        
        let datasetCreationDateString = moment(this.state.summary.datasetCreationDate).format(FRIENDLY_DATE_FORMAT);

        return (
            <Fragment>
                <SchoolPageTitle tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} title={`Usage ${datasetCreationDateString}`} />
                <AdminSchoolMenu tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} />
                <div className={"flex-row flex--justify-content-flex-end p-left-1rem p-right-1rem"}>
                    <Dropdown
                        selectedKey={this.state.summary.datasetId}
                        label={"Dataset"}
                        placeholder={"Select a Site Template"}
                        onChange={(e,o) => {
                            let dataset = o?.data as IUsageDatasetSummary;
                            window.open(`/cdb-admin/usage/${dataset.tenantId}/${dataset.schoolCode}/${dataset.id}`);
                        }}
                        options={datasetOptions}
                        styles={{ dropdown: { width: 300 } }}
                    />
                </div>
            
                <div className="usage-facts-card">
                    <div className={`usage-facts-card__area usage-facts-card__area--primary`}>
                        <div className={"flex-column"}>
                            <span>{this.state.summary.school.schoolName}</span>
                            <span className={"text-extra-detail"}>{datasetCreationDateString}</span>
                        </div>
                    </div> 
                </div>

                <SchoolUsageFactsCard title="Subjects" result={this.state.summary!.results["subject"]} area={"subject" as IUsageArea} facts={this.state.detail!.facts["subject"]}/>
                <SchoolUsageFactsCard title="Assignments" result={this.state.summary!.results["assignment"]} area={"assignment" as IUsageArea} facts={this.state.detail!.facts["assignment"]}/>
                <SchoolUsageFactsCard title="Notebooks" result={this.state.summary!.results["notebook"]} area={"notebook" as IUsageArea} facts={this.state.detail!.facts["notebook"]}/>
                <SchoolUsageFactsCard title="Student Folders" result={this.state.summary!.results["studentFolders"]} area={"studentFolders" as IUsageArea} facts={this.state.detail!.facts["studentFolders"]}/>
                <SchoolUsageFactsCard title="Home Site" result={this.state.summary!.results["homeSite"]} area={"homeSite" as IUsageArea} facts={this.state.detail!.facts["homeSite"]}/>
                <SchoolUsageFactsCard title="Staff Site" result={this.state.summary!.results["staffSite"]} area={"staffSite" as IUsageArea} facts={this.state.detail!.facts["staffSite"]}/>
                <SchoolUsageFactsCard title="Training Site" result={this.state.summary!.results["trainingSite"]} area={"trainingSite" as IUsageArea} facts={this.state.detail!.facts["trainingSite"]}/>
            </Fragment>
    );
    }
    }

    export default connect(
    (state: IRootState, ownProps: {
        match: any
    }): UsageSchoolDetailPageProps => {
        return {
            tenantId: ownProps.match.params.tenantId,
            schoolCode: ownProps.match.params.schoolCode,
            datasetId: ownProps.match.params.datasetId,
            apiService: state.auth.apiService,
        };
    }
    )(UsageSchoolDetailPage)